import Serializable from "@/core/misc/mixins/Serializable";
import Core from "@/core/Core";

type UTCOffset = `${'+' | '-'}${string}:${string}`;  // "-06:00"

class TimeZone extends Serializable {
    id: string;
    name: string;
    UTCOffset: UTCOffset;
    isDst: boolean;
    cities: string; // "Белиз, Сан-Игнасио, Бельмопан"

    static fromServer(data: any, result = new TimeZone()): TimeZone {
        super.fromServer(data, result);
        return result;
    }

    static fromBrowser(): TimeZone {
        const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        const timeZone = new TimeZone();
        /** Нужно удалять слеши, потому что наш компонент VSelect с ними не дружит */
        timeZone.id = browserTimeZone.replace(/\//g, ''); // удаляем слэши
        timeZone.UTCOffset = this.getBrowserUTCOffset();
        //timeZone.isDst: TimeZone.isDaylightSaving(now, browserTimeZone);
        timeZone.cities = this.#getMainCityForTimeZone(browserTimeZone);

        // AsiaNovosibirsk -> Asia/Novosibirsk
        timeZone.name = this.#addSlashBeforeSecondCapital(timeZone.id);

        return timeZone;
    }

    private static getBrowserUTCOffset(): UTCOffset {
        const offset = new Date().getTimezoneOffset();
        const hours = Math.floor(Math.abs(offset) / 60);
        const minutes = Math.abs(offset) % 60;
        const sign = offset <= 0 ? '+' : '-';

        return `${sign}${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}` as UTCOffset;
    }

    toString(): string {
        const sign = this.UTCOffset.charAt(0);           // '+' или '-'
        const hours = Number(this.UTCOffset.split(':')[0]); // "+07" -> 7, "-06" -> -6

        // Math.abs, потому что знак уже взяли отдельно из sign
        return `UTC${sign}${Math.abs(hours)}`;
    }

    get stringRepresentation(): string {
        return `(UTC${this.UTCOffset}) ${this.cities}`
    }

    get toDisplayString(): string {
        return `${this.name} (UTC ${this.UTCOffset})`
    }

    /*
    static isDaylightSaving(date: Date, timeZone: string): boolean {
        const january = new Date(date.getFullYear(), 0, 1);
        const july = new Date(date.getFullYear(), 6, 1);

        const janOffset = TimeZone.getOffsetForDate(january, timeZone);
        const julOffset = TimeZone.getOffsetForDate(july, timeZone);
        const currentOffset = TimeZone.getOffsetForDate(date, timeZone);

        return currentOffset !== Math.max(janOffset, julOffset);
    }
     */

    static #getMainCityForTimeZone(timezone: string): string {
        return timezone.split('/')[1] || timezone;
    }

    // AsiaNovosibirsk -> Asia/Novosibirsk
    static #addSlashBeforeSecondCapital(str: string): string {
        return str.replace(/([A-Z][a-z]+)([A-Z])/, '$1/$2');
    }

    // ============ Offset calculations ============

    static getBrowserToUserOffsetDiff(): number {
        const userOffset = Number(Core!.timeZone.UTCOffset.split(':')[0]);
        const browserOffset = Number(this.getBrowserUTCOffset().split(':')[0]);

        return userOffset - browserOffset;
    }

    static fromLocalStorage(data: any): TimeZone {
        const timeZone = new TimeZone();
        timeZone.id = data.id;
        timeZone.UTCOffset = data.UTCOffset;
        timeZone.isDst = data.isDst;
        timeZone.cities = data.cities;

        // AsiaNovosibirsk -> Asia/Novosibirsk
        function addSlashBeforeSecondCapital(str: string): string {
        	return str.replace(/([A-Z][a-z]+)([A-Z])/, '$1/$2');
        }

        timeZone.name = addSlashBeforeSecondCapital(timeZone.id);


        // timeZone.name = `(UTC${timeZone.UTCOffset}) ${timeZone.cities}`;

        return timeZone;
    }

    // абсолютно одинаковые
    // static fromServer = this.fromLocalStorage;
}

export default TimeZone;